// The app-side remainder of the `stream-http` split, plus name-intact
// re-exports of the four halves that moved at the data carve.
//
// `streamHeaders` reads the auth token and the `X-Client-*` pair — the last
// thing holding this family's `query` dimension amber — and both reads are
// ports now. There are deliberately TWO `stream-http.ts` in this package:
// `data/harness/stream/stream-http.ts` holds the four pure exports that were
// always headless, and this file holds the one that was not.
//
// HISTORY POINTER. `git log --follow` does NOT reach past the move for this file
// at git's default 50% similarity: the port rewrite replaced most of a small
// module, so the rename scores below the threshold. Either of these works:
//
//   git log --follow -M20% -- src/features/agent-harness/stream/stream-http.ts
//   git log -- src/features/agent-harness/stream/stream-http.ts
import { getAgentsDataConfig } from '../../../data/config';

export {
  responseError,
  shouldRetryStatus,
  sleep,
  StreamHttpError,
} from '../../../data/harness/stream/stream-http';

export const streamHeaders = ({
  lastEventId,
}: {
  lastEventId?: string | null;
}): Record<string, string> => {
  const { getAuthTokenSync, getClientHeaders } = getAgentsDataConfig();
  const token = getAuthTokenSync();
  return {
    Accept: 'text/event-stream',
    ...getClientHeaders(),
    ...(token && { Authorization: `Bearer ${token}` }),
    ...(lastEventId && { 'Last-Event-ID': lastEventId }),
  };
};
